export const PERMS = {
    READ: 'driver_surcharges.read',
    UPDATE: 'driver_surcharges.update',
    DELETE: 'driver_surcharges.delete',
    CREATE: 'driver_surcharges.create',
    EXPORT: 'driver_surcharges.export',
}
